'use strict'

import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .factory('BasSecurityAlarmTile', [
    'ICONS',
    'SECURITY',
    'BasUtilities',
    basSecurityAlarmTileFactory
  ])

/**
 * @param ICONS
 * @param SECURITY
 * @param BasUtilities
 * @returns BasSecurityAlarmTile
 */
function basSecurityAlarmTileFactory (
  ICONS,
  SECURITY,
  BasUtilities
) {

  /**
   * @constructor
   * @param {TBasAlarm} alarm
   */
  function BasSecurityAlarmTile (alarm) {
    /**
     * @type {string}
     */
    this.uuid = ''

    /**
     * @type {string}
     */
    this.name = ''

    /**
     * @type {string}
     */
    this.translationKey = ''

    /**
     * @type {Object}
     */
    this.capabilities = {}

    /**
     * @type {string}
     */
    this.state = ''

    /**
     * @type {Array<TBasAlert>}
     */
    this.alerts = []

    /**
     * @type {boolean}
     */
    this.canDisarm = false

    /**
     * @type {boolean}
     */
    this.hasCapabilities = false

    /**
     * @type {boolean}
     */
    this.canArm = false

    /**
     * @type {string}
     */
    this.uiIcon = ''

    /**
     * @type {string}
     */
    this.uiName = ''

    if (alarm) this.parse(alarm)
  }

  /**
   * @param {TBasAlarm} basAlarm
   */
  BasSecurityAlarmTile.prototype.parse = function (basAlarm) {

    if (BasUtil.isNEString(basAlarm.uuid)) {
      this.uuid = basAlarm.uuid
    }

    if (BasUtil.isNEString(basAlarm.name)) {
      this.name = basAlarm.name
    }

    if (BasUtil.isObject(basAlarm.capabilities)) {
      this.capabilities = basAlarm.capabilities
      this.hasCapabilities = BasUtil.isNEObject(basAlarm.capabilities)
      this.canArm = basAlarm.capabilities.arm === 'x'
    }

    if (BasUtil.isNEString(basAlarm.state)) {
      this.state = basAlarm.state
    }

    if (BasUtil.isNEArray(basAlarm.alerts)) {
      this.alerts = basAlarm.alerts
    }

    if (BasUtil.isNEString(basAlarm.translationKey)) {
      this.translationKey = basAlarm.translationKey
    }

    this._syncAlarmUI(this.translationKey)
  }

  /**
   * @param {string} type
   */
  BasSecurityAlarmTile.prototype.changeType = function (type) {

    this._syncAlarmUI(type)
  }

  /**
   * @param {string} translationKey
   */
  BasSecurityAlarmTile.prototype._syncAlarmUI = function (translationKey) {
    const ALARM_PREFIX = 'alarm_'

    const homeAlarms = [
      SECURITY.BAS_ALARM_TYPE_NIGHT,
      SECURITY.BAS_ALARM_TYPE_HOME
    ]
    const awayAlarms = [
      SECURITY.BAS_ALARM_TYPE_AWAY,
      SECURITY.BAS_ALARM_TYPE_VACATION,
      SECURITY.BAS_ALARM_TYPE_CUSTOM
    ]

    if (translationKey !== SECURITY.BAS_ALARM_TYPE_DISARM) {

      this.uiName = this.name + ' ' + BasUtilities.translate(
        ALARM_PREFIX + this.translationKey
      )
    } else {

      this.uiName = BasUtilities.translate(ALARM_PREFIX + this.translationKey)
    }

    if (homeAlarms.includes(translationKey)) {

      this.uiIcon = ICONS[SECURITY.BAS_ALARM_ICON_HOME]
    } else if (awayAlarms.includes(translationKey)) {

      this.uiIcon = ICONS[SECURITY.BAS_ALARM_ICON_AWAY]
    } else if (translationKey === SECURITY.BAS_ALARM_TYPE_DISARM) {

      this.uiIcon = ICONS[SECURITY.BAS_ALARM_ICON_DISARMED]
    }
  }

  /**
   * @param {string} uiName
   */
  BasSecurityAlarmTile.prototype.setUiName = function (uiName) {
    this.uiName = uiName
  }

  /**
   * @param {string} uiIcon
   */
  BasSecurityAlarmTile.prototype.setUiIcon = function (uiIcon) {
    this.uiIcon = ICONS[uiIcon]
  }

  return BasSecurityAlarmTile
}
